// Accordion rows (.collapsible-content-item). Shared by the Collapsible content
// section and the product page Collapsible content block: rows that sit in the same
// parent form one accordion, so opening a row closes its siblings.
if (typeof window.initCollapsibleItems !== "function") {
  const transitionDuration = "400ms";
  const transitionType = "ease-in-out";

  // Selector for all natively focusable elements.
  const FOCUSABLE =
    'a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])';

  // Collapses an element by animating its height and opacity to zero.
  const slideUp = (element) => {
    if (!element) return;
    const height = element.getBoundingClientRect().height;

    element.style.height = `${height}px`;
    element.style.overflow = "hidden";
    element.style.transition = `height ${transitionDuration} ${transitionType}, opacity ${transitionDuration} ${transitionType}`;

    void element.offsetHeight;

    element.style.height = "0";
    element.style.opacity = "0";

    const cleanup = () => {
      element.style.removeProperty("overflow");
      element.style.removeProperty("transition");
      element.removeEventListener("transitionend", cleanup);
    };

    element.addEventListener("transitionend", cleanup);
  };

  // Expands an element by animating its height from zero to full scroll height.
  const slideDown = (element) => {
    if (!element) return;

    element.style.removeProperty("display");
    let display = window.getComputedStyle(element).display;
    if (display === "none") display = "block";
    element.style.display = display;

    const height = element.scrollHeight;

    element.style.height = "0";
    element.style.opacity = "0";
    element.style.overflow = "hidden";
    element.style.transition = `height ${transitionDuration} ${transitionType}, opacity ${transitionDuration} ${transitionType}`;

    void element.offsetHeight;

    element.style.height = `${height}px`;
    element.style.opacity = "1";
  };

  // Enables or disables tab focus for all focusable elements inside the answer panel.
  const setAnswerFocusability = (item, isOpen) => {
    const answer = item.querySelector(".collapsible-content-item__answer");
    if (!answer) return;
    answer.querySelectorAll(FOCUSABLE).forEach((el) => {
      if (isOpen) {
        el.removeAttribute("tabindex");
      } else {
        el.setAttribute("tabindex", "-1");
      }
    });
  };

  const collapse = (item) => {
    item.classList.remove("active");
    item.removeAttribute("data-default-opened");
    item.setAttribute("aria-expanded", "false");
    slideUp(item.querySelector(".collapsible-content-item__answer"));
    setAnswerFocusability(item, false);
  };

  // Rows sharing a parent belong to the same accordion list.
  const closeSiblings = (currentItem) => {
    const parent = currentItem.parentElement;
    if (!parent) return;

    Array.from(parent.children).forEach((child) => {
      if (child === currentItem) return;
      if (!child.classList.contains("collapsible-content-item")) return;
      collapse(child);
    });
  };

  // Toggles the clicked row open or closed. Ignores clicks on links inside the answer.
  const handleClick = (event) => {
    const item = event.currentTarget;

    const answer = item.querySelector(".collapsible-content-item__answer");
    if (!answer) return;

    if (event.target && event.target.closest && event.target.closest("a")) {
      return;
    }

    if (item.classList.contains("active")) {
      collapse(item);
    } else {
      closeSiblings(item);
      item.classList.add("active");
      slideDown(answer);
      item.setAttribute("aria-expanded", "true");
      setAnswerFocusability(item, true);
    }
  };

  const handleKeydown = (event) => {
    if (event.key !== "Enter" && event.key !== " ") return;
    const item = event.currentTarget;
    const answer = item.querySelector(".collapsible-content-item__answer");
    if (answer && answer.contains(document.activeElement)) return;
    event.preventDefault();
    handleClick({ currentTarget: item });
  };

  window.initCollapsibleItems = function initCollapsibleItems(root) {
    const scope =
      root && typeof root.querySelectorAll === "function" ? root : document;

    scope.querySelectorAll(".collapsible-content-item").forEach((item) => {
      if (item.dataset.collapsibleReady === "true") return;
      item.dataset.collapsibleReady = "true";

      const answer = item.querySelector(".collapsible-content-item__answer");
      if (answer && item.getAttribute("data-default-opened") === "true") {
        answer.style.height = `${answer.scrollHeight}px`;
      }
      setAnswerFocusability(item, item.classList.contains("active"));

      item.addEventListener("click", handleClick);
      item.addEventListener("keydown", handleKeydown);
    });
  };

  // Rows are removed together with their section, so the listeners go with them
  document.addEventListener("shopify:section:load", (event) => {
    window.initCollapsibleItems(event.target);
  });
}

window.initCollapsibleItems(document);
